module.exports = __webpack_public_path__ + "img/DINERS.png";